<template>
  <UFormField name="clientId" label="Organization" required>
    <USelectMenu
      :model-value="modelValue"
      @update:model-value="emit('update:modelValue', $event)"
      v-model:search-term="orgSearchTerm"
      :items="filteredOrganizations"
      :loading="organizationsLoading"
      value-key="keycloakId"
      label-key="name"
      ignore-filter
      class="w-full"
      placeholder="Search organization..."
    />
    <p v-if="!organizationsLoading && organizations.length === 0"
       class="text-sm text-amber-500 mt-1">
      No organizations retrieved
    </p>
  </UFormField>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import Fuse from 'fuse.js';
import type { OrganizationDto } from '@/api/eOrdersApi';

const props = defineProps<{
  organizations: OrganizationDto[];
  organizationsLoading: boolean;
  modelValue: string;
}>();

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>();

const orgSearchTerm = ref('');

const orgFuse = computed(() =>
  new Fuse(props.organizations, {
    threshold: 0.3,
    ignoreLocation: true,
    keys: ['name'],
  })
);

const filteredOrganizations = computed(() => {
  const selected = props.organizations.find(o => o.keycloakId === props.modelValue);
  let items: OrganizationDto[];
  
  if (!orgSearchTerm.value) {
    items = props.organizations.slice(0, 50);
  } else {
    items = orgFuse.value.search(orgSearchTerm.value, { limit: 50 }).map(r => r.item);
  }

  if (selected && !items.some(i => i.keycloakId === selected.keycloakId)) {
    items = [selected, ...items];
  }

  return items;
});

watch(() => props.organizations, (orgs) => {
  if (orgs?.length === 1) {
    emit('update:modelValue', orgs[0].keycloakId);
  }
});
</script>
